import React, { useEffect } from "react";
import Marquee from "react-fast-marquee";
import Heading from "../Highlightedheading/Heading";
import Aos from "aos";

import { partners } from "../../assets/PartnersNew";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Grid, FreeMode } from "swiper/modules";
import "swiper/css";
import "swiper/css/grid";
import "./partner.scss"; // Import SCSS file

export const Partners = () => {
  return (
    <section id="partner_section" className="w-full h-full relative">
      <div className="px-4 pt-[60px] md:px-[7.2vw] md:pt-[10px]">
        <Heading headingText="OUR PARTNERS" />
      </div>

      <div className="mt-8 flex flex-col gap-[7px] md:gap-4">
        <Swiper
          slidesPerView={2}
          freeMode={true}
          speed={2500}
          spaceBetween={7}
          centeredSlides={false}
          loop={true}
          grabCursor={true}
          modules={[FreeMode, Autoplay]}
          autoplay={{
            delay: 0,
            disableOnInteraction: false,
          }}
          breakpoints={{
            768: {
              slidesPerView: 4,
              spaceBetween: 16,
            },
            1024: {
              slidesPerView: 5,
              spaceBetween: 16,
            },
            1920: {
              slidesPerView: 6,
              spaceBetween: 16,
            },
          }}
        >
          {partners?.slice(0, 20)?.map((img, i) => (
            <SwiperSlide key={`slide-${i}`}>
              {/* <div
                key={`partners-${i}`}
                // className="bg-glass backdrop-blur-xl flex justify-center items-center aspect-[16/6] w-full"
                className="bg-glass backdrop-blur-xl flex justify-center items-center w-full !h-[150px]"
              >
                <img
                  src={img}
                  alt={`Partners-Logo-${i}`}
                  // className={`!object-contain ${
                  //   i === 1 ? "max-w-[80%]" : "max-w-[60%]"
                  // }`}
                  className="max-w-[50%] !object-contain"
                />
              </div> */}

              <div
                key={`partners-${i}`}
                className="bg-glass backdrop-blur-xl w-full"
              >
                <img src={img} alt={`Partners-Logo-${i}`} className="" />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
        <Swiper
          slidesPerView={2}
          freeMode={true}
          speed={2500}
          spaceBetween={7}
          centeredSlides={false}
          loop={true}
          grabCursor={true}
          modules={[FreeMode, Autoplay]}
          autoplay={{
            delay: 0,
            disableOnInteraction: false,
          }}
          breakpoints={{
            768: {
              slidesPerView: 4,
              spaceBetween: 16,
            },
            1024: {
              slidesPerView: 5,
              spaceBetween: 16,
            },
            1920: {
              slidesPerView: 6,
              spaceBetween: 16,
            },
          }}
        >
          {partners?.slice(20, partners?.length)?.map((img, i) => (
            <SwiperSlide key={`slide-${i}`}>
              {/* <div
                key={`partners-${i}`}
                className="bg-glass backdrop-blur-xl flex justify-center items-center aspect-[16/6] w-full"
              >
                <img
                  src={img}
                  alt={`Partners-Logo-${i}`}
                  className={`!object-contain max-h-[70%] ${
                    i === 1 ? "max-w-[80%]" : "max-w-[60%]"
                  }`}
                />
              </div> */}
              <div
                key={`partners-${i}`}
                className="bg-glass backdrop-blur-xl w-full"
              >
                <img src={img} alt={`Partners-Logo-${i}`} className="" />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default Partners;
